import {
  Component,
  ChangeDetectionStrategy,
  TemplateRef,
  OnInit,
  Input,
} from '@angular/core';
import {
  startOfDay,
  endOfDay,
  subDays,
  addDays,
  endOfMonth,
  isSameDay,
  isSameMonth,
  subHours,
  addHours,
  endOfWeek,
  startOfWeek,
  addMinutes,
  subMonths,
  startOfMonth,
  addMonths
} from 'date-fns';
import { Subject } from 'rxjs';
import {
  CalendarEvent,
  CalendarEventAction,
  CalendarEventTimesChangedEvent,
  CalendarView
} from 'angular-calendar';
import { InstructorService } from "src/app/service/instructor.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Lesson } from "src/app/model/lesson.model";
import { ReservationSubItem } from "src/app/model/reservation.model";
import { MatDialog } from "@angular/material";
import { LessonDetailComponent } from "../../lesson/lesson-detail/lesson-detail.component";
import { LessonService } from "src/app/service/lesson.service";
import { DeleteConfirmationDialog } from "../../delete-confirmation/delete-confirmation.dialog";
import { LessonSelectionComponent } from "../../lesson/lesson-selection/lesson-selection.component";
import { TimeSlot } from "src/app/model/time-slot.model";
import { Role } from "src/app/model/role.model";
import { AuthService } from "src/app/service/auth.service";
import { User } from "src/app/model/user.model";
import { Instructor } from "src/app/model/instructor.model";
import { DatePipe } from '@angular/common';
import { ReservationService } from 'src/app/service/reservation.service';
import { EquipmentTimeSlot } from 'src/app/model/equipment-time-slot.model';
import { DataService } from 'src/app/service/data.service';
import { Grouptype } from 'src/app/model/grouptype';
import { TranslationPipe } from 'src/app/pipes/translation.pipe';

const colors: any = [
  {
    primary: "#9B98F1",
    secondary: "#8d8aef"
  },
  {
    primary: "#a1c3e5",
    secondary: "#b3d9ff"
  },
  {
    primary: "#ffb3b3",
    secondary: "#ff8080"
  },
  {
    primary: "#ffe0b3",
    secondary: "#ffcc80"
  }
];
@Component({
  selector: 'app-schedule-equipment',
  templateUrl: './schedule-equipment.component.html',
  styleUrls: ['./schedule-equipment.component.css']
})
export class ScheduleEquipmentComponent implements OnInit {
  view: CalendarView = CalendarView.Month;
  weekStartsOn = 1;
  CalendarView = CalendarView;
  refresh: Subject<any> = new Subject();
  viewDate: Date = new Date();
  events: CalendarEvent<EquipmentTimeSlot>[] = [];
  groupTypes: Grouptype[];
  reservedEquipmentTimeSlots: EquipmentTimeSlot[];
  selectedgroupTypeId = 0;
  /* filterName: string; */
  currentUser: User;
  activeDayIsOpen: boolean = false;

  constructor(private reservationService: ReservationService, private dataService: DataService, private translationPipe: TranslationPipe,private router: Router) { }

  ngOnInit() {
    this.dataService.getGroupTypes().subscribe(data => {
      this.groupTypes = data as Grouptype[];
      this.groupTypes.push(new Grouptype(0, "Sve", "lblAll"))   
    });
    this.showReservedEquipmentTimeSlots(true);
  }



  showReservedEquipmentTimeSlots(all: boolean, grouptype?: number) {
    if (all) {
      this.reservationService
        .getReservedEquipmentTimeSlots()
        .subscribe(data => {
          this.reservedEquipmentTimeSlots = data as EquipmentTimeSlot[];
          this.reloadEvents();
        });
    }
    else {
      this.reservationService
        .getReservedEquipmentTimeSlots(grouptype)
        .subscribe(data => {
          this.reservedEquipmentTimeSlots = data as EquipmentTimeSlot[];
          this.reloadEvents();
        });
    }
  }

  public reloadEvents() {
    this.events = [];
    for (const timeslot of this.reservedEquipmentTimeSlots) {
      this.events.push({
        start: new Date(timeslot.dateFrom),
        end: new Date(timeslot.dateTo),
        title: this.translationPipe.transform(this.groupTypes.filter(x => x.id === timeslot.groupType)[0].description) + ' (' +
        this.translationPipe.transform( timeslot.equipment)+') '+ 
        '- '+this.translationPipe.transform("lblPaymentInitQuantity") + ': '+timeslot.kolicina + ' '+
        this.translationPipe.transform("lblPaymentFinishReservationId")+': '+ timeslot.reservationId,
        color: colors[timeslot.groupType - 1],
        meta: timeslot,
        id: timeslot.reservationId
      });
    }
    this.refresh.next();
  }

  getRecordGroupType(groupType) {
    this.selectedgroupTypeId = groupType.id;
    this.showReservedEquipmentTimeSlots(false, groupType.id);
    this.activeDayIsOpen = false;
  }

  getGroupColor(groupType): string {
    if (groupType.id == 0) {
      return "Grey"
    }
    else {
      return colors[groupType.id - 1].primary;
    }
  }

/*   getFilteredGroupTypes(): Grouptype[] {
    if (this.filterName && this.filterName !== '') {
      return this.groupTypes.filter(i => (i.description).toLowerCase().includes(this.filterName.toLowerCase()));
    }
    return this.groupTypes;
  } */
  
  get isAdmin() {
    return this.currentUser && this.currentUser.role === Role.Admin;

  }

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }

  handleEvent(event: CalendarEvent): void {
    this.router.navigateByUrl('/reservation-process/' + event.id,{ state: { reservationListOrEquipment: 'equipment' } });
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }
}
